/* 请求接口地址管理 */

console.log("process.env.NODE_ENV", process.env.NODE_ENV);
export var IP =
         process.env.NODE_ENV === "development"
           ? "/proxy-server" //本地代理 http://172.16.100.88:9020
           : "https://lejian-api.bboycc.cn";

export var loginIp ="" //账号密码登录